<template>
    <div class="wrapper">
        <dash-header></dash-header>
        <sidebar></sidebar>
        <div class="content-wrapper">
            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h1 class="m-0 title">Change Password</h1>
                        </div><!-- /.col -->
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><router-link to="/dashboard">Home</router-link></li>
                            <li class="breadcrumb-item active">Change Password</li>
                            </ol>
                        </div><!-- /.col -->
                    </div><!-- /.row -->
                </div>
            </section>
            <section class="content edit_profile">
                <div class="container-fluid">
                    <form id="edit-profile" @submit.prevent="editProfile()">
                        <div class="row">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <div v-if="message" class="alert alert-danger" role="alert">{{message.message}}</div>
                                </div>
                                <div class="form-group">
                                    <div v-if="success" class="alert alert-success" role="alert">{{success}}</div>
                                </div>
                                <div class="form-group">
                                    <label for="password">New Password</label>
                                    <div class="input-group">
                                        <input type="password" v-model="password" v-validate="'required|min:8|max:40'" ref="password" class="form-control field-password" id="password" name="password">
                                        <div class="input-group-append show_pass">
                                            <span class="input-group-text"><i @click="showPassword" class="eye-icon bi bi-eye"></i></span>
                                        </div>
                                    </div>
                                    <div v-if="submitted && password == ''" class="text-danger">
                                        New Password required
                                    </div>
                                    <div v-else-if="submitted && password.length <8" class="text-danger">
                                        The New Password must be at least 8 characters
                                    </div>
                                    <div v-else-if="submitted && errors.has('password')" class="text-danger">
                                        {{errors.first('password')}}
                                    </div>
                                    <div v-if="message.password" class="text-danger">
                                        {{message.password[0]}}
                                    </div>
                                    <input type="hidden" v-model="id" class="form-control" id="id" name="id">
                                </div>
                                <div class="form-group">
                                    <label for="password_confirmation">Confirm New Password</label>
                                    <div class="input-group">
                                        <input type="password" v-model="password_confirmation" v-validate="'required|confirmed:password'" data-vv-as="password" class="form-control field-password2" id="password_confirmation" name="password_confirmation">
                                        <div class="input-group-append show_pass2">
                                            <span class="input-group-text"><i @click="showPasswordC" class="eye-icon bi bi-eye eye_open"></i></span>
                                        </div>
                                    </div>
                                    <div v-if="submitted && password_confirmation == ''" class="text-danger">
                                        New Password Confirmation Required
                                    </div>
                                    <div v-else-if="submitted && errors.has('password_confirmation')" class="text-danger">
                                        {{errors.first('password_confirmation')}}
                                    </div>
                                    <div v-if="message.password_confirmation" class="text-danger">
                                        {{message.password_confirmation[0]}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-sm-2 c-btn">
                                <router-link to="/profile" class="btn btn_outline_red btn-block mb-3">Cancel</router-link>
                            </div>
                            <div class="col-sm-4 up-btn">
                                <button type="submit" class="btn btn_red btn-block mb-3" :disabled="loading">
                                    <span v-show="loading" class="spinner-border spinner-border-sm mr-2"></span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 31.5 31.5">
                                        <g id="save_icon" transform="translate(-223.85 -684)">
                                            <path id="Icon_awesome-save" data-name="Icon awesome-save" d="M30.511,9.136l-5.9-5.9a3.375,3.375,0,0,0-2.386-.989H3.375A3.375,3.375,0,0,0,0,5.625v24.75A3.375,3.375,0,0,0,3.375,33.75h24.75A3.375,3.375,0,0,0,31.5,30.375V11.523a3.375,3.375,0,0,0-.989-2.386Z" transform="translate(223.85 681.75)" fill="#fff" opacity="0.5"/>
                                            <path id="Union_5" data-name="Union 5" d="M-2894,18a5,5,0,0,1,5-5,5,5,0,0,1,5,5,5,5,0,0,1-5,5A5,5,0,0,1-2894,18Zm-6-9a1,1,0,0,1-1-1V1a1,1,0,0,1,1-1h17a1,1,0,0,1,1,1V8a1,1,0,0,1-1,1Z" transform="translate(3129 688)" fill="#fff"/>
                                        </g>
                                    </svg>
                                    Update Password
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import DashHeader from "../layouts/Header.vue";
// import DashFooter from "../layouts/Footer.vue";
import Sidebar from "../layouts/Sidebar.vue";
import axios from 'axios'
import jwt_decode from "jwt-decode"

// import VuePhoneNumberInput from 'vue-phone-number-input';
// import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
    name: "ChangePassword",
    components: {
        DashHeader,
        // DashFooter,
        Sidebar,
        // VuePhoneNumberInput
    },
    data(){
		return{
			dataakun: [],
			akunemail: '',
			message: '',
			success: '',
			loading: false,
            submitted: false,
			// datainvestor:{
			// 	id:"",
			// 	password:"",
			// 	password_confirmation:"",
			// }
            id:"",
			password:"",
			password_confirmation:"",
		}
	},
    async mounted() {
		// if(!this.currentUser) {
		// 	this.$router.push('/login');
		// }
		
		var token = localStorage.getItem('access_token')
		var access_token = jwt_decode(token)
		const user_id = access_token.user_id
		if(!localStorage.getItem('user_id')){
			localStorage.setItem('user_id', user_id)
		}

		await axios.get(`investor/${localStorage.user_id}`)
		.then(result => {
			// console.log('Profile: ', result.data.data)
			this.dataakun = result.data.data
			this.akunemail = result.data.data.email
            // this.datainvestor = result.data.data;
			// if(result.data.data.identity_file == null)
            // {
            //   this.$router.push('profile/update')
            // }
		}).catch(() => {
			// console.log('Error Profile: ', err.response)
		})
	},
	methods: {
		// sendUser(dataakun) {
		// 	this.datainvestor = dataakun;
		// 	console.log("Get Data Investor", this.datainvestor)
		// },
        showPassword() {
            const input = document.querySelector('.field-password')
            const show = document.querySelector('.eye-icon')
            if(input.type === 'password') {
                show.classList.remove('bi-eye')
                show.classList.add("bi-eye-slash")
                input.type = 'text'
            } else {
                show.classList.remove("bi-eye-slash")
                show.classList.add('bi-eye')
                input.type = 'password'
            }
        },
        showPasswordC() {
            const input = document.querySelector('.field-password2')
            const show = document.querySelector('.eye_open')
            if(input.type === 'password') {
                show.classList.remove('bi-eye')
                show.classList.add("bi-eye-slash")
                input.type = 'text'
            } else {
                show.classList.remove("bi-eye-slash")
                show.classList.add('bi-eye')
                input.type = 'password'
            }
        },
		editProfile(){
            this.submitted = true
			// if(this.akunemail == this.datainvestor){
				let data = new FormData()
				data.append('id', this.dataakun.id)
				data.append('password', this.password)

                this.$validator.validate().then(isValid => {
                    if(isValid) {
                        axios.put(`investor/${this.dataakun.id}/`, data)
                        .then((response) => {
                            // console.log(response);
                            // if(response.data.data.status === 200) {
                                this.loading = true
                                this.success = response.data.message
                                setTimeout(() => {
                                    this.$router.push({ path: `/profile` })
                                }, 2000)
                                // swal('Data edited successfully', 'Please re-check your data.', 'success', {
                                // 	button: "OK"
                                // })
                                // this.$bvModal.hide('modal-edituser')
                                // $(this.$refs.editModal).on("hidden.bs.modal")
                                
                                // window.location.reload()
                                // return router.push({
                                    // name: 'Login'
                                // })
                            // } else {
                            // 	this.loading = false
                            // 	// validation.value = response.data.response
                            // 	// console.log(validation);
                            // }
                        }).catch((error) => {
                            this.loading = false
                            this.message = error.response.data.data
                            // console.log(error.response)
                        })
                    }else{
                        this.loading = false
                    }
                })
			// }
		}
	}
}
</script>

<style scoped>
.edit_profile img.img_identity{
    width: auto;
    height: 80px;
    margin-top: 20px;
}
.edit_profile img.img_identity2{
    width: auto;
    height: 80px;
    margin-top: 20px;
}
.edit_profile .photo_upload input[type="file"] {
    display: none;
}
.edit_profile .photo_upload .custom-file-upload {
    border: 1px solid #ccc;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    border-radius: 5px;
    margin-bottom: 40px;
    display: flex;
    /* width: 50%; */
    align-items: center;
    justify-content: center;
}

.edit_profile .form-group{
    margin-bottom: 5px;
}
.edit_profile .form-group label{
    font-size: 10pt;
    margin: 0;
}
.edit_profile input.form-control{
    padding: 15px;
}

.edit_profile .btn_outline_red{
    padding: 10px !important;
}

@media(max-width: 767.98px){
    .c-btn{
        order: 2;
    }
    .up-btn{
        order: 1;
    }
}
</style>